import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageHeader from "../shared/page-header/PageHeader";
import SKAlerts, { CreateAlert } from "../shared/common-alerts/SKAlerts";
import axios from "axios";
import { getApiBaseUrl } from "../utils/apiConfig";
import { getStorageValues } from "../shared/CommonFunctions";

function ResetPassword(props) {
  const [alert, setAlert] = useState(null);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = (e) => {
    e.preventDefault();
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };
  const handleChangePassword = async (e) => {
    e.preventDefault();

    // 🔹 Validation
    if (!oldPassword || !newPassword || !confirmPassword) {
      CreateAlert("All fields are required", "Error", setAlert);
      return;
    }
    if (newPassword !== confirmPassword) {
      CreateAlert("New password and confirm password do not match", "Error", setAlert);
      return;
    }

    try {
      setLoading(true);
      let resetPasswordDetails = {
        UserId: getStorageValues('userId'),
        OldPassword: oldPassword,
        NewPassword: newPassword
      };
      // 🔹 API call (adjust API path if needed)
      const res = await axios.post(getApiBaseUrl() + "/resetPassword", resetPasswordDetails);

      CreateAlert(res.data.message || "Password changed successfully!", "Success", setAlert);

      // reset form
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      CreateAlert(
        err.response?.data?.message || "Failed to change password",
        "Error",
        setAlert
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* 🔹 Alert Box */}
      <SKAlerts alert={alert} />

      <PageHeader
        displayModule={props.Module}
        displayText={"Manage "}
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={false}
        showAddButton={false}
      />

      <div className="card">
        <div className="card-body">
          <div className="row">
            <h4 className="mb-3">
              Enter New Password & Confirm Password to get inside
            </h4>

            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">Old Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
              </div>
            </div>

            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
            </div>

            <div className="col-lg-6 col-sm-12">
              <div className="mb-3">
                <label className="form-label">Confirm New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>

            <div className="col-12">
              <button
                className="btn btn-submit me-2"
                onClick={handleChangePassword}
                disabled={loading}
              >
                {loading ? "Changing..." : "Change Password"}
              </button>
              <Link to="" className="btn btn-cancel" onClick={handleReset}>
                Reset
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
